export const appConfig = {
	officeTitle: 'המשרד לביטחון הפנים',
	pageTile: 'מחשבון לבדיקת זכאות לרישיון כלי ירייה פרטי',
	maxAge: 85,
	defaultAge: 25
};



// WEBPACK FOOTER //
// ./src/assets/config/app.config.ts